import Base from "./base";

export class MonetixPagamigos extends Base {
	makeExternalPayment() {
		const { stake } = this.state;
		let withdrawData = {
			type: "Pagamigos",
			amount: {
				value: stake,
				currency: this.props.wallet.total.currency
					? this.props.wallet.total.currency
					: "BRL",
			},
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
